import { MainConfig } from "./mainconfig";
import { features } from "./features";

import { language, dateStyle, regions, offices, provinces } from "./language";

import { countries, default_country_code } from "./countries";

import * as COLORS from "./colors";
import * as ASSETS from "./assets";
import * as LANGUAGE from "./appLanguage";
import * as VERSIONS from "./appVersions";
const AppDetails = MainConfig.AppDetails;
const FirebaseConfig = MainConfig.FirebaseConfig;
const Google_Map_Key = MainConfig.Google_Map_Key;
const facebookAppId = MainConfig.facebookAppId;
const SentryMobileConfig = MainConfig.SentryMobileConfig;
const SentryWebConfig = MainConfig.SentryWebConfig;


const STYLES = {
  ...COLORS,
  ...ASSETS,
  ...LANGUAGE
}

const PurchaseDetails = MainConfig.PurchaseDetails;
const Google_Calendar_Key = MainConfig.Google_Calendar_Key;
const Calendar_Client_Id = MainConfig.Calendar_Client_Id;
const Calendar_Discovery_Docs = MainConfig.Calendar_Discovery_Docs;
const Calender_Scope = MainConfig.Calender_Scope;

const mainUrl = "cloudfunctions.net";
const cloud_function_server_url = `https://us-central1-${FirebaseConfig.projectId}.${mainUrl}`;
const meetinglinkurl =
  "https://dev.okdoc.co.za:9091/plugins/restapi/v1/chatrooms";

export {
  SentryWebConfig,
  Google_Calendar_Key,
  Calendar_Client_Id,
  Calendar_Discovery_Docs,
  Calender_Scope,
  AppDetails,
  language,
  VERSIONS,
  offices,
  regions,
  FirebaseConfig,
  Google_Map_Key,
  SentryMobileConfig,
  STYLES,
  PurchaseDetails,
  dateStyle,
  facebookAppId,
  meetinglinkurl,
  cloud_function_server_url,
  features,
  countries,
  default_country_code,
  mainUrl,
};
